import { useQuery } from '@tanstack/react-query';
import { repoMarginCallService } from '@/services/trades/repo-margin-call-service';
import { tradesKeys } from '@/services/query-keys/trades-keys';
import type { RepoMarginCallBalance } from '@/types';

/**
 * GET /repo-margin-calls/balance/ — what a counterparty's repo book holds in the cash pools, read
 * from the pool ledger, and its split by pool. See `RepoMarginCallBalance` for when `currency` is
 * blank and `cashpool` null. Disabled until a CP is known.
 */
export const useRepoMarginCallBalance = (
  counterpartyName: string | undefined,
  enabled = true,
) => {
  return useQuery<RepoMarginCallBalance>({
    queryKey: tradesKeys.repoMarginCallBalance(counterpartyName ?? ''),
    queryFn: () => repoMarginCallService.getBalance(counterpartyName as string),
    enabled: enabled && !!counterpartyName,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
  });
};
